<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout align-center row>
      <v-spacer />
      <v-btn
        color="accent"
        class="action-bar__btn"
        round
        depressed
        @click="$router.push({ name: 'ApprovePaymentBulkOperation' })"
      >
        {{ $t(`${namespace}.bulkAction`) }}
      </v-btn>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen
    })
  },
  data () {
    return {
      namespace: 'Views.PaymentStatusPage',
      breadcrumbItems: [
        { title: this.$t('Views.FinancialPage.title') },
        { name: 'ApprovePayment', title: this.$t('Views.PaymentStatusPage.title') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    }
  }
}
</script>
